export const DEFAULT_REFETCH_INTERVAL_MS = 30000; // 30s

// Live progress tables (volumes list, actions list)
export const TABLE_LIVE_REFRESH_MS = 5000; // 5s

// Utilization charts should trail real time to avoid jitter at head of series
export const UTILIZATION_TRAILING_LAG_MS = 30000; // 30s

// Future padding added to end time for time-range queries to absorb clock skew
export const FUTURE_HEAD_PADDING_MS = 5 * 60 * 1000; // 5 minutes

export const DEBOUNCE_MS = 1000;
